import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";
import { object } from "prop-types";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../../molecules/StoryMetaData";

import "./relatedStory.m.css";

const RelatedStory = ({ story }) => {
  const [imageType, setImageType] = useState("image3x2");

  useEffect(() => {
    if (global.deviceWidth < 876) {
      setImageType("image1x1");
    }
  }, []);

  return (
    <div className="related-story-each" styleName="related-story" key={story.id} data-testid="related-storys">
      <div className="story-data">
        <Link href={story.url} target="_blank" rel="noopener noreferrer">
          <Headline text={story.headline} headerLevel={3} headlineType={16} />
        </Link>
        <StoryMetaData story={story} isAuthor={false} showComments={false} isPublished={false} />
      </div>
      <div>
        <Link href={story.url} target="_blank" rel="noopener noreferrer">
          <CardImage story={story} imageType="image3x2" showAlternateImage={true} widths={[150]} />
        </Link>
      </div>
    </div>
  );
};

RelatedStory.propTypes = {
  story: object.isRequired,
};

export default RelatedStory;
